export default "__VITE_ASSET__GPsgWcYH__"